<template>
  <aw-dropdown
    placement="bottom-start"
    :offset="[0, 6]"
    class="relative cursor-pointer"
  >
    <template v-slot:btn="{ toggle }">
      <div>
        <aw-icon
          @click="toggle"
          title="edit url"
          icon="cog"
          class="
            w-4
            h-4
            text-gray-400
            hover:text-gray-500
            
            
            cursor-pointer
          "
        ></aw-icon>
      </div>
    </template>
    <template v-slot:dropdown="{ opened, dropdown, close }">
      <div
        v-show="opened"
        :ref="dropdown"
        class="
          Dropdown Dropdown--Full  w-full
          Dropdown--SuperShadow
          absolute
          rounded-md
          bg-white
          text-sm
          top-full
          right-0
          shadow-md
          z-10
        "
      >
        <div class="px-2 py-3">
          <form class="flex items-center">
            <textarea  class="form-control" v-model="url" />
            <input
              type="submit"
              class="btn flex-shrink-0 ml-2"
              :class="{ 'btn-primary': isValid, 'btn-disabled': !isValid }"
              :value="$t('Save')"
              @click.prevent.stop="updateUrl(close)"
            />
          </form>
          <span v-show="!isValid" class="text-red-500">
            {{$t('Please enter valid URL or embed code')}}
          </span>
        </div>
      </div>
    </template>
  </aw-dropdown>
</template>
<script>
import Embed from '../../mixins/Embed'
import EmbedLogic from '../../mixins/EmbedLogic'

export default {
  mixins: [Embed, EmbedLogic],
 
}
</script>
